import type { convites as pt } from '../pt-BR/convites';
import type { Traducao } from '../Traducao';

export const convites = {
  status: { nao_enviado: 'Not sent', enviado: 'Accepted by the server', falha: 'Failed' },
  lembrar: {
    titulo_one: "{{count}} hasn't answered",
    titulo_other: "{{count}} haven't answered",
    enviar: 'Send e-mail',
    pessoas_zero: '{{count}} people',
    pessoas_one: '{{count}} person',
    pessoas_other: '{{count}} people',
    copiarEmails: 'Copy e-mails',
    bloco: '{{de}}–{{ate}}',
    copiarLink: 'Copy link',
    copiados_one: '{{count}} copied',
    copiados_other: '{{count}} copied',
    linkCopiado: 'Link copied',
    semEmail: '{{count}} without e-mail',
  },
  statusDica: {
    enviado:
      'The e-mail server accepted the message; it does not mean it was delivered or read. Does not include messages on Teams or WhatsApp.',
  },
  iniciadaIgnorados_one:
    'Sending started. {{count}} person was not in the campaign and was skipped.',
  iniciadaIgnorados_other:
    'Sending started. {{count}} people were not in the campaign and were skipped.',
  previa: {
    titulo: 'Email preview',
    de: 'From',
    para: 'To',
    assunto: 'Subject',
    exemplo: 'Example with a fictional name',
    semDestinatario: 'This person would not receive the email: no email or domain on their record',
    verPessoa: 'View the email this person receives',
  },
  rodada: {
    status: { em_andamento: 'In progress' },
    barra: '{{processados}} · {{enviados}}, {{falhas}} failed',
    processados_one: '{{feitos}} of {{count}} processed',
    processados_other: '{{feitos}} of {{count}} processed',
    enviados_zero: '{{count}} sent',
    enviados_one: '{{count}} sent',
    enviados_other: '{{count}} sent',
  },
  ultimoEnvio: {
    titulo: 'Last e-mail send',
    concluido_zero: '{{count}} e-mails sent on {{quando}} by {{nome}}',
    concluido_one: '{{count}} e-mail sent on {{quando}} by {{nome}}',
    concluido_other: '{{count}} e-mails sent on {{quando}} by {{nome}}',
    falhas_one: '{{count}} failed',
    falhas_other: '{{count}} failed',
    interrompido: 'Sending stopped on {{quando}}: {{enviados}} of {{total}} sent.',
  },
  detalhe: { semTentativas: 'No sending attempts.', resultado: 'Reason', historico: 'Attempts' },
  idioma: {
    rotulo: 'E-mail language',
    cadaUm: "Each person's language",
    previa: 'View in',
  },
  modelo: {
    titulo: 'E-mail text',
    padrao: 'Default text',
    editadoPor: 'Edited by {{nome}} on {{quando}}',
    corpo: 'Body',
    voltarSalvar: 'Go back and save',
    saidaTitulo: 'There is unsaved text',
    salvar: 'Save text',
    descartar: 'Discard',
    restaurar: 'Restore default',
    restaurarTitulo: 'Restore the default text?',
    restaurarCorpo: 'The edited text for this language is deleted and the default comes back.',
    salvo: 'Text saved. The next sends use this text.',
    restaurado: 'Default text restored.',
    variavelDesconhecida:
      'Unknown variable in the text: {{variaveis}}. Use {nome}, {campanha}, {inicio} or {fim}.',
  },
  envio: {
    publico_zero: '{{count}} people',
    publico_one: '{{count}} person',
    publico_other: '{{count}} people',
    resumo: '{{pessoas}}, {{receberao}}',
    receberao_zero: '{{count}} will receive it',
    receberao_one: '{{count}} will receive it',
    receberao_other: '{{count}} will receive it',
  },
  dialogo: {
    titulo: 'Send invitations',
    enviar: 'Send',
  },
} as const satisfies Traducao<typeof pt>;
